/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon16Light = forwardRef('MailIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.8 5.6a.5.5 0 0 0-.6.8L6 8.5a2.5 2.5 0 0 0 3 0l2.8-2.1a.5.5 0 0 0-.6-.8L8.4 7.7a1.5 1.5 0 0 1-1.8 0L3.8 5.6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h8a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3h-8ZM2 5.5A1.5 1.5 0 0 1 3.5 4h8A1.5 1.5 0 0 1 13 5.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 2 10.5v-5Z" })));
});
